//
// Accordion
//
function accordion() {
	const accordions = document.querySelectorAll('.accordion');
	accordions.forEach((accordion) => {
		const lists = accordion.querySelectorAll('li');

		// Open the first accordion item onload
		// if (lists.length > 0) {
		// 	const firstList = lists[0];
		// 	const firstText = firstList.querySelector('.answer');
		// 	const firstHeight = firstText.scrollHeight;

		// 	firstList.classList.add('active');
		// 	firstList.setAttribute('aria-expanded', 'true');
		// 	firstText.style.maxHeight = firstHeight + 'px';
		// }

		lists.forEach((list) => {
			list.addEventListener('click', (e) => {
				e.preventDefault();
				console.log(list);

				const text = list.querySelector('.answer');

				var height = text.scrollHeight;

				// Close other lists
				lists.forEach((otherList) => {
					// console.log(otherList);

					if (otherList !== list) {
						const otherText = otherList.querySelector('.answer');
						if (otherText) {
							otherText.style.setProperty('max-height', '0px');
						}
						// console.log(otherText.style);
						otherList.classList.remove('active');
						otherList.setAttribute('aria-expanded', 'false');
					}
				});

				// Toggle current list
				var aria =
					list.getAttribute('aria-expanded') === 'true'
						? 'false'
						: 'true';
				list.setAttribute('aria-expanded', aria);

				if (list.getAttribute('aria-expanded') === 'false') {
					text.style.maxHeight = '0px';
					list.classList.remove('active');
					list.setAttribute('aria-expanded', 'false');
				} else {
					text.style.maxHeight = height + 'px';
					list.classList.add('active');
					list.setAttribute('aria-expanded', 'true');
				}
			});
		});
	});
}
// window.addEventListener('DOMContentLoaded', accordion);
accordion();

// Import Tingle.js
import tingle from 'tingle.js';

// Create a global variable to keep track of the currently opened modal
let currentModal = null;

// var modal = new tingle.modal({
//     footer: true,
//     stickyFooter: false,
//     closeMethods: ['overlay', 'button', 'escape'],
//     closeLabel: "Close",
//     cssClass: ['modal-video'],
//     onOpen: function () {
//         console.log('modal open');
//     },
//     onClose: function () {
//         console.log('modal closed');
// 		this.destroy();
// 		console.log('close');
//     },
//     beforeClose: function () {
//         // here's goes some logic
//         // e.g. save content before closing the modal
//         return true; // close the modal
//         return false; // nothing happens
//     }
// });

// Function to transform a video URL into an embeddable format
function transformVideoUrl(videoUrl) {
	if (videoUrl) {
		if (videoUrl.includes('vimeo.com')) {
			// Extract the video ID from the Vimeo URL
			const vimeoVideoID = videoUrl.match(/\/(\d+)/)[1];
			// Construct the Vimeo embed URL
			return `https://player.vimeo.com/video/${vimeoVideoID}`;
		} else if (videoUrl.includes('youtube.com')) {
			// Extract the video ID from the YouTube URL
			const youtubeVideoID = videoUrl.match(/v=([^&]+)/)[1];
			// Construct the YouTube embed URL
			return `https://www.youtube.com/embed/${youtubeVideoID}`;
		} else if (
			videoUrl.includes('.mp4') ||
			videoUrl.includes('.webm') ||
			videoUrl.includes('.ogv')
		) {
		}
	}
	return videoUrl;
}

const videoControls = document.querySelectorAll('.video-controls');
videoControls.forEach((videoControl) => {
	videoControl.addEventListener('click', (e) => {
		e.preventDefault();
		const videoUrl = videoControl.getAttribute('data-video-url');
		const transformedVideoUrl = transformVideoUrl(videoUrl); // Transform the URL

		// Check if there's an existing modal, destroy it before creating a new one
		if (currentModal) {
			currentModal.destroy();
			currentModal = null; // Clear the current modal reference
		}

		let modalContent;

		if (
			videoUrl.includes('vimeo.com') ||
			videoUrl.includes('youtube.com')
		) {
			// Use iframe for Vimeo or YouTube URLs
			modalContent = `<iframe src="${transformedVideoUrl}" width="800" height="450" frameborder="0" allowfullscreen></iframe>`;
		} else {
			// Use HTML5 video element for other URLs
			const desiredWidth = 800;
			modalContent = `
                <video controls width="${desiredWidth}" height="auto">
                    <source src="${transformedVideoUrl}" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            `;
		}

		// Create a new tingle modal instance
		const modal = new tingle.modal({
			footer: false,
			stickyFooter: false,
			closeMethods: ['overlay', 'button', 'escape'],
			closeLabel: 'Close',
			cssClass: ['custom-class-1', 'custom-class-2'],
			onOpen: () => {
				console.log('modal open');
				// Change the width of the video iframe after the modal is opened
				const mediaIframe = document.querySelector(
					'iframe[name="media"]',
				);
				console.log(mediaIframe);
				if (mediaIframe) {
					mediaIframe.style.width = `100%`;
				}
			},
			onClose: () => {
				currentModal = null; // Clear the current modal reference on modal close
				console.log('close');
				modal.destroy();
			},
			beforeClose: function () {
				// here's goes some logic
				// e.g. save content before closing the modal
				return true; // close the modal
				return false; // nothing happens
			},
		});

		// Set the modal content
		modal.setContent(modalContent);

		// Open the modal
		modal.open();

		currentModal = modal;
	});
});

// document.addEventListener('DOMContentLoaded', function () {

// Get all elements with the class 'popup-link'
var popupLinks = document.querySelectorAll('.popup-link');

// Create Tingle modal instance
var modal = new tingle.modal({
	footer: true,
	stickyFooter: false,
	closeMethods: ['overlay', 'escape'],
	closeLabel: 'Close',
	cssClass: ['modal-team'],
});

// Add click event listener to each popup link
popupLinks.forEach(function (link) {
	link.addEventListener('click', function (event) {
		event.preventDefault();

		// console.log('pew');
		var modalContent = '';

		var modalContent =
			'<span class="close-button"><svg version="1.1" id="b" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 14 14" enable-background="new 0 0 14 14" xml:space="preserve"><path fill="#4D4D4F" d="M8.5,8.5h4C13.3,8.5,14,7.8,14,7c0-0.8-0.7-1.5-1.5-1.5h-4v-4C8.5,0.7,7.8,0,7,0C6.2,0,5.5,0.7,5.5,1.5v4 h-4C0.7,5.5,0,6.2,0,7c0,0.4,0.2,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1.1,0.4h4l0,4c0,0.4,0.2,0.8,0.4,1.1S6.6,14,7,14 c0.8,0,1.5-0.7,1.5-1.5C8.5,12.5,8.5,8.5,8.5,8.5z"/></svg></span>';

		var imageSrc = link.getAttribute('data-image-src');
		var imageWidth = link.getAttribute('data-image-width');
		var imageHeight = link.getAttribute('data-image-height');
		var name = link.getAttribute('data-name');
		var role = link.getAttribute('data-role');
		var excerpt = link.getAttribute('data-excerpt');
		var data_external_link = link.getAttribute('data-external-link');
		if (data_button_text) {
			var data_button_text = link.getAttribute('data-button-text');
		} else {
			var data_button_text = 'Read More';
		}
		modalContent += '<div class="image">';
		modalContent +=
			'<div class="shapes"><div class="grey"><svg width="201" height="200" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg" class="solid"><rect x="0.511719" width="200" height="200" rx="100" fill="#F26E21"></rect></svg></div><div class="orange"><svg width="201" height="200" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg" class="solid"><rect x="0.511719" width="200" height="200" rx="100" fill="#F26E21"></rect></svg></div><div class="grey-light"><svg width="202" height="202" viewBox="0 0 202 202" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke"><mask id="mask0_789_320" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="4" y="4" width="193" height="193"><path d="M95.9917 196.359C43.2668 193.653 2.71902 148.716 5.42566 95.9915C8.1323 43.2666 53.0684 2.7188 105.793 5.42544C158.518 8.13208 199.066 53.0682 196.359 105.793C193.653 158.518 148.717 199.066 95.9917 196.359Z" fill="white" stroke="white"></path></mask><g mask="url(#mask0_789_320)"><path d="M134.559 -52.5684L-64.7684 127.783" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M140.127 -46.417L-59.2 133.935" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M145.689 -40.2764L-53.6375 140.075" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M151.252 -34.1211L-48.075 146.231" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M156.803 -27.9717L-42.5235 152.366" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M162.369 -21.8281L-36.9578 158.524" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M167.939 -15.6758L-31.3875 164.676" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M173.508 -9.53711L-25.8192 170.815" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M179.061 -3.38281L-20.2665 176.969" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M184.625 2.77441L-14.702 183.126" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M190.197 8.90723L-9.12977 189.259" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M195.756 15.0625L-3.57111 195.414" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M201.316 21.2148L1.99008 201.553" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M206.879 27.3584L7.55194 207.71" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M212.447 33.5117L13.1203 213.864" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M218.02 39.6523L18.6926 220.004" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M223.568 45.8057L24.2414 226.158" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M229.127 51.9619L29.8007 232.3" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M234.691 58.1045L35.3644 238.456" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M240.256 64.2529L40.9289 244.605" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M245.814 70.3955L46.4875 250.747" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M251.385 76.5449L52.0578 256.897" stroke="#F7F7F7" stroke-miterlimit="10"></path><path d="M256.951 82.7012L57.6242 263.053" stroke="#F7F7F7" stroke-miterlimit="10"></path></g></svg></div></div>';
		modalContent += `<img src="${imageSrc}" width="${imageWidth}" height="${imageHeight}" alt="Image">`;
		modalContent += '</div>';

		modalContent += '<div>';
		modalContent += '<div>';
		modalContent += `<h5>${name}</h5>`;
		modalContent += `<p style="font-weight: bold;">${role}</p>`;
		modalContent += '</div>';
		modalContent += `${excerpt}`;

		if (data_external_link) {
			modalContent += `<a href="${data_external_link}" class="button solid orange" tabindex="0" target="_blank"><span>${data_button_text}</span></a>`;
		}
		modalContent += '</div>';

		modal.setContent(modalContent);

		// Add event listener for the close button inside the modal
		var closeButton = document.querySelector('.close-button');
		closeButton.addEventListener('click', function () {
			// Close the Tingle modal
			modal.close();
		});

		// Open the Tingle modal
		modal.open();
	});
});

// });

function initCounters() {
	// Get all counter elements
	const counterItems = document.querySelectorAll('.counter-number');

	if (!counterItems.length) return;

	// Options for the Intersection Observer
	const options = {
		root: null, // viewport
		rootMargin: '0px',
		threshold: 0.2 // trigger when 20% of the element is visible
	};

	// Callback for Intersection Observer
	const handleIntersection = (entries, observer) => {
		entries.forEach(entry => {
		// If element is in view and hasn't been animated yet
		if (entry.isIntersecting && !entry.target.dataset.counted) {
			const startValue = parseInt(entry.target.dataset.start) || 0;
			const endValue = parseInt(entry.target.dataset.end) || 100;
			const duration = 2000; // Animation duration in milliseconds
			const stepTime = 50; // Time between each step in milliseconds
			const steps = duration / stepTime;
			const increment = (endValue - startValue) / steps;

			// Mark as counted so we don't animate it again
			entry.target.dataset.counted = 'true';

			let currentValue = startValue;
			const counter = setInterval(() => {
			currentValue += increment;

			// Stop at end value
			if (
				(increment > 0 && currentValue >= endValue) ||
				(increment < 0 && currentValue <= endValue)
			) {
				clearInterval(counter);
				currentValue = endValue;
			}

			// Update the display - use toLocaleString for number formatting
			entry.target.textContent = Math.round(currentValue).toLocaleString();
			}, stepTime);

			// Stop observing this element
			observer.unobserve(entry.target);
		}
		});
	};

	// Create the observer
	const observer = new IntersectionObserver(handleIntersection, options);

	counterItems.forEach(counter => {
		observer.observe(counter);
	});
}

document.addEventListener('DOMContentLoaded', initCounters);
initCounters();


function findMarkerByPostId(postId) {
    const map = jQuery.goMap.map;
    let foundMarker = null;

    function search(layer) {
        if (foundMarker) return;

        // Some markers store ID in options.id
        if (layer._latlng && (layer.options?.post_id == postId || layer.options?.id == postId)) {
            foundMarker = layer;
            return;
        }

        if (layer._layers) {
            Object.values(layer._layers).forEach(sub => search(sub));
        }
    }

    Object.values(map._layers).forEach(layer => search(layer));
    return foundMarker;
}

function handlePropertyClick(e) {
    const article = e.target.closest('.geodir-listing');
    if (!article) return;

    e.preventDefault();

    const postId = article.dataset.postId;
    const marker = findMarkerByPostId(postId);

	console.log(postId);

    if (marker) {
        const map = jQuery.goMap.map;
        map.setView(marker._latlng, 15);

        marker.fire('click');

        // Open the popup if it exists
        if (marker._popup) {
            marker._popup._isOpen || marker._popup.openOn(map);
        } else {
            console.warn('Marker has no popup:', marker);
        }
    } else {
        console.warn('Marker not found for post ID', postId);
    }
}

document.addEventListener('click', handlePropertyClick);
